module.exports = __webpack_public_path__ + "img/icon_sub_03.7ff5b66e.jpg";